import type { NativeServices } from '@forest/native-services'
import { Loading } from './lib/loading'

export const loadingBifrost = new Loading<NativeServices>()
